import $ from "jquery";

$(async function() {
    const storageKey = "user_currency_code";

    if (sessionStorage.getItem(storageKey)) {
        updateCurrencyOnPage(sessionStorage.getItem(storageKey));
        return;
    }

    const url = "https://api.ipregistry.co/?key=ira_TVE4OmFO85mx04BMfwvjcJu4rEZadz2MBlGk";

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
    
        const json = await response.json();
        const code = json.currency.code;
        console.log("Currency Code:", code);

        // Store currency code in sessionStorage
        sessionStorage.setItem(storageKey, code);
        
        // Update currency on page
        updateCurrencyOnPage(code);

        // Send AJAX request to store currency in WordPress
        $.ajax({
            url: '/wp-admin/admin-ajax.php', 
            type: 'POST',
            data: {
                action: 'update_currency_code',
                currency_code: code
            },
            success: function(response) {
                console.log('Currency code updated successfully:', response);
            },
            error: function(xhr, status, error) {
                console.error('AJAX error:', error);
            }
        });
    } catch (error) {
        console.error(error.message);
    }
});

// Function to update the currency display dynamically
function updateCurrencyOnPage(currencyCode) {
    const currencySymbols = {
        'GBP': '£',
        'EUR': '€',
        'AUD': '$',
        'USD': '$'
    };

    const priceElements = document.querySelectorAll(".price-display");
    priceElements.forEach((element) => {
        let price;
        switch (currencyCode) {
            case "GBP": price = element.dataset.ukPrice; break;
            case "EUR": price = element.dataset.euPrice; break;
            case "AUD": price = element.dataset.ausPrice; break;
            default: price = element.dataset.usPrice;
        }
        element.innerHTML = `${currencySymbols[currencyCode] || "$"}${price}`;
    });
}
